<template>
    <div class="footer-page">
        <el-row class="footer" :gutter="50">
            <el-col class="footer-col" :span="10">
                <el-image class="logo" :src="logo"></el-image>
                <p class="title">{{ $t('footer.online_service') }}</p>
                <div class="footer-hints">
                    <div class="footer-hint-left">
                        <p>{{ $t('footer.service_hotline') }}</p>
                        <p>400-181-0855</p>
                        <p>400-895-6696</p>
                    </div>
                    <div class="footer-hint-right">
                        <p>{{ $t('footer.online_time') }}</p>
                        <p>09:00-12:00 13:00-17:00</p>
                        <p>{{ $t('footer.opening_days') }}</p>
                    </div>
                </div>
                <p class="address">{{ $t('footer.address') }}</p>
            </el-col> 
            <!-- 底部二维码：仅在中文 / 英文时展示，俄语隐藏（保留列布局，避免左侧内容居中） -->
            <el-col :span="14">
                <!-- 底部二维码：仅在中文 / 英文时展示 -->
                <el-row v-if="locale !== 'ru'" :gutter="50">
                    <el-col :span="8">
                        <el-image :src="code1"></el-image>
                        <p class="code-title">{{ $t('footer.vitalqi_official_account') }}</p>
                    </el-col>
                    <el-col :span="8">
                        <el-image :src="code2"></el-image>
                        <p class="code-title">{{ $t('footer.warm_life_official_account') }}</p>
                    </el-col>
                    <el-col :span="8">
                        <el-image :src="code3"></el-image>
                        <p class="code-title">{{ $t('footer.nuanya_official_account') }}</p>
                    </el-col>
                </el-row>
                <!-- 俄语模式登录按钮：放在原二维码区域 -->
                <div v-if="locale === 'ru'" class="footer-login-wrap">
                    <div class="footer-login-btn" @click="goLogin">
                        {{ $t('footer.login') }}
                    </div>
                </div>
            </el-col> 
        </el-row>
        <div class="footer-bottom">
            <p>{{ $t('footer.copyright') }}</p>
        </div>
    </div>
</template>
<script setup lang="ts">
import code1 from '@/assets/image/other/1.webp';
import code2 from '@/assets/image/other/2.webp';
import code3 from '@/assets/image/other/3.webp';
import logo from '@/assets/image/other/logo.webp';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const goLogin = () => {
  // 俄语下登录，跳转到外部登录页
  window.location.href = 'https://h5.lifsong365.com/#/login';
};
</script>
<style lang="scss" scoped>
.footer-page{
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: #7A7A7A;
}
.footer{
  width: 1400px;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 66px;
  .footer-col{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .logo{
        width: 500px;
    }
    .title{
        margin-top: 30px;
        color: #fff;
        text-align: left;
        font-size: 24px;
    }
    .footer-hints{
        margin-top: 15px;
        color: #fff;
        display: flex;
        justify-content: space-between;
        width: 100%;
        .footer-hint-left{
            text-align: left;
        }
        .footer-hint-right{
            text-align: left;
        }
        p{
            height: 30px;
            line-height: 30px;
        }
    }
    .address{
        margin-top: 43px;
        color: #fff;
        text-align: left;
    }
  }
  .code-title{
      color: #fff;
      font-size: 1.2em;
      margin-top: 15px;
  }
  .footer-login-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .footer-login-btn {
          border: 1px solid #fff;
          padding: 12px 36px;
          border-radius: 4px;
          color: #fff;
          font-size: 1.2em;
          cursor: pointer;
          transition: all 0.3s ease;
          &:hover {
              background-color: rgba(255, 255, 255, 0.1);
              border-color: #FF5D07;
              color: #FF5D07;
          }
      }
  }
}
.footer-bottom{
    width: 100%;
    height: 60px;
    background-color: #0e0e0e;
    color: #494D4D;
    display: flex;
    justify-content: center;
    align-items: center;
    p{
        font-size: 1em;
    }
}

</style>